import { createSelector } from 'reselect';
var getRoot = function (_a) {
    var auth = _a.auth;
    return auth;
};
export var getAuthToken = createSelector(getRoot, function (state) { return (state === null || state === void 0 ? void 0 : state.token) || null; });
export var getIsLoggedIn = createSelector(getAuthToken, function (token) {
    return Boolean(token);
});
export var getAuthIsLoading = createSelector(getRoot, function (_a) {
    var isLoading = _a.isLoading;
    return Boolean(isLoading);
});
export var getAuthError = createSelector(getRoot, function (_a) {
    var error = _a.error;
    return error;
});
